import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import {
  WidgetPatchBody,
  TExportTableWidgetSettingsLoaded
} from 'types/GlobalWidget'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/export-tables`

export async function update(
  exportTableId: string,
  widgetId: string,
  body: WidgetPatchBody
) {
  return axios.patch<{ data: TExportTableWidgetSettingsLoaded }>(
    `${URL}/${exportTableId}/widgets/${widgetId}`,
    body,
    parseAuthenticationHeader()
  )
}
